import React, { Component } from "react";
import { connect } from "react-redux";
import { reduxForm, reset } from "redux-form";
import { BaseComponent } from "BaseComponent";
import _ from "lodash";
import { Modal } from "react-bootstrap";
import Button from "react-bootstrap-button-loader";
import {
  openLocationMapModal,
  insertLocationMap,
  editLocationMap,
  updateLocationMap,
} from "LocationMapActions";
import { checkContentDashboardStatus } from "GeneralTabAction";
import { showError, showSuccess } from "ReduxErrorBar";
import { COMMON_FAIL_MESSAGE, maxLengthObjectFc } from "Constants";
import LocationMapBody from "./location-map-add-form";
import LocaleStrings from "Languages";
var MAXLENOBJ = {};
class LocationMap extends Component {
  constructor(props) {
    super(props);
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
    this.onMapChangeCallback = this.onMapChangeCallback.bind(this);
    this.onFormSubmit = this.onFormSubmit.bind(this);
    this.onLocationChangeCallback = this.onLocationChangeCallback.bind(this);
    this.state = { showModal: false, loading: false };
  }

  componentDidMount() {
    MAXLENOBJ = maxLengthObjectFc(this.props.history); // filter This form name object With route
  }

  onLocationChangeCallback(params) {
    this.setState({
      showModal: this.state.showModal,
      loading: this.state.loading,
      center: this.state.center,
      zoom: this.state.zoom,
      location: params.name,
    });
  }

  onMapChangeCallback(params) {
    this.setState({
      showModal: this.state.showModal,
      loading: this.state.loading,
      center: params.center,
      zoom: params.zoom,
      location: this.state.location,
    });
  }

  open() {
    this.props.reset();
    this.props.editLocationMap({});
    this.props.openLocationMapModal(true);
  }

  close() {
    this.props.openLocationMapModal(false);
    this.props.reset();
  }

  onFormSubmit(values) {
    values.name = values.name.trim();
    if (values.city) {
      values.city = values.city.trim();
    }
    if (values.state) {
      values.state = values.state.trim();
    }
    if (values.zipcode) {
      values.zipcode = values.zipcode.trim();
    }
    // debugger;
    this.setState({ ...this.state, loading: true });
    // call action to save the map to database, api call
    values = {
      ...values,
      eventid: this.props.session.eventid,
      location: values.location.label,
      placeid: values.location.value,
    };
    // console.log("values :- ", values);

    var callback = (response) => {
      if (response.success === 0) {
        this.setState({ ...this.state, loading: false });
        this.props.showError(COMMON_FAIL_MESSAGE);
      } else {
        this.setState({ ...this.state, loading: false });
        this.props.showSuccess("Location Map list updated successfully");
        this.props.checkContentDashboardStatus(this.props.session);
      }
    };
    if (values.mapid) {
      this.props.updateLocationMap(this.props.session, values, callback);
    } else {
      this.props.insertLocationMap(this.props.session, values, callback);
    }
  }

  render() {
    var { handleSubmit, reset, invalid, pristine, submitting } = this.props;

    return (
      <div>
        <div className="map-menuitem" onClick={this.open}>
          {LocaleStrings.map_locationmap}
        </div>

        <Modal
          className="modal-container "
          show={this.props.showModal}
          onHide={this.close}
          animation={true}
          keyboard={false}
          backdrop="static"
        >
          <form onSubmit={handleSubmit(this.onFormSubmit)}>
            <Modal.Header>
              <div className="import-modal-title">
                {LocaleStrings.map_locationmap}
              </div>

              <button
                type="button"
                className="i-custom-cross-popup pull-right"
                onClick={() => this.close()}
              >
                <img
                  className="i-custom-small"
                  src="../../style/images/custom-icons/cross-black.png"
                />
              </button>
            </Modal.Header>
            <Modal.Body>
              <LocationMapBody
                {...this.props}
                callback={this.onMapChangeCallback}
                onLocationChange={this.onLocationChangeCallback}
              />
            </Modal.Body>
            <Modal.Footer>
              <Button
                bsStyle="primary"
                loading={this.state.loading}
                type="submit"
                disabled={pristine || invalid || submitting}
              >
                {LocaleStrings.map_savechanges}
              </Button>
            </Modal.Footer>
          </form>
        </Modal>
      </div>
    );
  }
}

function validate(values) {
  var maxLengthFields = ["name"];
  var errors = {};
  if (!values.name || values.name.trim() === "") {
    errors.name = LocaleStrings.map_mapname;
  }

  if (_.size(values.location) === 0) {
  } else if (values.location && !values.location.label) {
    errors.location = LocaleStrings.map_location;

    errors.location = LocaleStrings.map_location;
  }

  /*** Max Length Validation ***/
  maxLengthFields.forEach((field) => {
    if (values[field] && MAXLENOBJ) {
      if (values[field].length > MAXLENOBJ[field]) {
        errors[field] = LocaleStrings.max_characters_left + MAXLENOBJ[field];
      }
    }
  });

  return errors;
}

function mapStateToProps(state) {
  var initVals = state.initialLocationMap;

  if (initVals.length > 0)
    initVals = {
      ...initVals,
      location: {
        name: initVals?.location ? initVals.location : "",
        placeid: initVals?.placeid ? initVals?.placeid : "",
      },
    };

  return {
    session: state.session,
    showModal: state.showLocationMapModal,
    initialValues: initVals,
  };
}

export default connect(mapStateToProps, {
  openLocationMapModal,
  insertLocationMap,
  showError,
  showSuccess,
  editLocationMap,
  updateLocationMap,
  checkContentDashboardStatus,
})(
  reduxForm({
    validate,
    form: "LocationMapForm",
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
  })(LocationMap)
);
